<script setup>
import { computed, onMounted } from "vue";

import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";
import init from "components/compositions/softness_score/component";

const props = defineProps({
  value: {
    default: 0.0,
    type: [String, Number]
  }
});

const show = computed(() => props.value);
onMounted(init);
</script>

<template>
  <div v-if="show" class="print-softness-score js-softness-score-tooltip" tabindex="0">
    <div class="print-softness-score__number">
      <UseSvg icon="softness-clear" class="print-softness-score__icon" type="print" />
      {{ value }}
    </div>
    <h2 class="print-softness-score__label">
      <span>
        Cozy<b>Feel</b>™
        <span class="print-softness-score__sublabel" />
      </span>
    </h2>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/pod/settings";

.print-softness-score {
  color: $link-blue;
  display: flex;
  flex-direction: column;

  &__number {
    font-size: 12px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 2px;
    justify-content: center;
    line-height: 12px;
  }

  &__icon {
    width: 12px;
    height: 12px;
  }

  &__label {
    font-size: 10px;
    font-weight: 500;
    text-align: center;
  }
}
</style>
